import Layout from '@/layout/index.vue'
const route = [
  {
    path: '/pages',
    component: Layout,
    redirect: '/dashboard',
    meta: { title: '业务管理', icon: 'el-icon-Setting' },
    children: [
      {
        name:'order',
        path: 'order',
        component: () => import('@/views/order/index.vue'),
        meta: { title: '订单管理', icon: 'el-icon-CreditCard'}
      },{
        name:'blacklist',
        path: 'blacklist',
        component: () => import('@/views/blacklist/index.vue'),
        meta: { title: '黑名单管理', icon: 'el-icon-User'}
      },{
        name:'goods',
        path: 'goods',
        component: () => import('@/views/goods/index.vue'),
        meta: { title: '商品管理', icon: 'el-icon-Files'}
      }
    ]
  }
]

export default route